import {AxiosInstance, AxiosResponse} from 'axios';
//types
import {IContributionResponse} from '@/utils/types';
//enum
import {API_URL} from '../enums/api-url.enum';

class OrganizationAttendeesContributionsService {
	static getAttendeesContributionsList = async (
		attendeeId: number,
		apiInstance: AxiosInstance
	): Promise<AxiosResponse<IContributionResponse>> =>
		apiInstance.get(`${API_URL.GET_ATTENDEE_AUCTION_CONTRIBUTIONS}/${attendeeId}`);
}

export {OrganizationAttendeesContributionsService};
